/** @jsx jsx */

import * as React from "react";
import { tagsStyle, tagStyle, tagCheckboxStyle } from "./tagsStyle";
import { jsx } from "@emotion/core";
import AppUtils from "../../../utils/AppUtils";

export interface Tag {
  name: string,
  isSelected?: boolean
}

interface TagsProps {
  name: string,
  tags: Array<Tag>,
  onTagClick: (name: string, tags: Array<Tag>) => void
}

const Tags: React.SFC<TagsProps> = (props) => {

  const onTagClick = (tag: Tag) => {
    const newTags = [...props.tags].map((innerTag: Tag) => {
      if (tag.name === innerTag.name) {
        innerTag.isSelected = !innerTag.isSelected;
      }
      return innerTag;
    });
    props.onTagClick(props.name, newTags);
  }

  return (
    <div css={tagsStyle.tagsContainer}>
      {props.tags.map((tag: Tag) => {
        return (
          <div key={tag.name} css={tagStyle(tag.isSelected, AppUtils.getIsMobile())} onClick={() => { onTagClick(tag) }}>
            <div css={tagCheckboxStyle(tag.isSelected)}></div>
            <div>{tag.name}</div>
          </div>
        )
      })}
    </div>
  )
}

export default Tags;